import { BaseComponent } from "./BaseComponent";

export abstract class BaseReplaceContentComponent extends BaseComponent<HTMLElement> {
  private _parent: HTMLElement;

  constructor(parent: HTMLElement) {
    super();
    //
    this._parent = parent;
  }

  //

  protected getParent(): HTMLElement {
    return this._parent;
  }

  protected abstract getTemplateString(): string;

  protected abstract getData(): any;

  protected afterInit(_parent: HTMLElement): void {}

  protected beforeDispose(_parent: HTMLElement): void {}

  //

  public init(): void {
    this._parent.innerHTML = this.createHtmlString(
      this.getTemplateString(),
      this.getData(),
    );
    this.afterInit(this._parent);
  }

  public dispose(): void {
    this.beforeDispose(this._parent);
    this._parent.innerHTML = "";
  }
}
